import { render, staticRenderFns } from "./colorCodeImage.vue?vue&type=template&id=65af3ba1&scoped=true&"
import script from "./colorCodeImage.vue?vue&type=script&lang=js&"
export * from "./colorCodeImage.vue?vue&type=script&lang=js&"
import style0 from "./colorCodeImage.vue?vue&type=style&index=0&id=65af3ba1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af3ba1",
  null
  
)

export default component.exports